import Confetti from 'react-confetti';
import styled from 'styled-components';
import useWindowSize from 'utils/hooks/useWindowSize';

export const InitialConfetti = () => {
  const { width, height } = useWindowSize();

  return (
    <StyledConfetti
      width={width}
      height={height}
      numberOfPieces={1000}
      gravity={0.1}
      initialVelocityX={4}
      initialVelocityY={10}
      wind={0}
      recycle={false}
      style={{
        width: '100%',
        // TODO: Find out why I can't use 100vh here which still creates a scrollbar
        height: '97vh'
      }}
    />
  );
};

const StyledConfetti = styled(Confetti)`
  width: 100%;
  // TODO: Find out why I can't use 100vh here which still creates a scrollbar
  height: 97vh;
`;
